import client from '../data/client';

export default () => {
  localStorage.removeItem('authToken');
  client.resetStore();
};



// WEBPACK FOOTER //
// ./src/helpers/logout.js